import { Link } from 'react-router-dom';

const techniqueServices = [
  {
    icon: 'ri-flashlight-line',
    title: 'Électricité',
    description: 'Installations électriques conformes aux normes NIBT/OIBT suisses. Domotique, dépannage 24/7 et commerce de matériel.',
    features: ['Installation complète', 'Mise aux normes NIBT/OIBT', 'Dépannage 24/7', 'Domotique'],
    link: '/electricite',
    linkText: "Voir l'électricité",
    iconBg: 'bg-amber-500',
    checkColor: 'text-amber-400',
    image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20installing%20electrical%20panel%20switchboard%20in%20modern%20building%20Switzerland%20clean%20white%20background%20technical%20work%20tools%20equipment%20certified&width=600&height=380&seq=elec-univers-02&orientation=landscape',
  },
  {
    icon: 'ri-windy-line',
    title: 'Ventilation & Climatisation',
    description: "VMC double flux, climatisation et purification d'air pour un intérieur sain. Service professionnel dans tout le canton.",
    features: ['VMC double flux', 'Climatisation', "Purification d'air", 'Entretien régulier'],
    link: '/ventilation',
    linkText: 'Voir la ventilation',
    iconBg: 'bg-sky-500',
    checkColor: 'text-sky-400',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20ventilation%20system%20installation%20modern%20building%20ceiling%20Switzerland%20clean%20white%20technical%20professional%20air%20conditioning%20unit&width=600&height=380&seq=ventil-univers-02&orientation=landscape',
  },
  {
    icon: 'ri-water-flash-line',
    title: 'Sanitaire',
    description: 'Plomberie, salles de bains et détection de fuites. Expertise reconnue à Neuenegg pour résidences et commerces.',
    features: ['Plomberie générale', 'Salles de bains', 'Détection de fuites', 'Intervention rapide'],
    link: '/sanitaire',
    linkText: 'Voir le sanitaire',
    iconBg: 'bg-indigo-500',
    checkColor: 'text-indigo-400',
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20bathroom%20renovation%20plumbing%20installation%20white%20tiles%20shower%20Switzerland%20professional%20clean%20minimal%20design&width=600&height=380&seq=sanitaire-univers-02&orientation=landscape',
  },
  {
    icon: 'ri-temp-hot-line',
    title: 'Pompes à Chaleur',
    description: 'Systèmes de chauffage écologiques et performants. Installation, maintenance et optimisation énergétique en Suisse romande.',
    features: ['Pompes à chaleur', 'Chauffage au sol', 'Maintenance préventive', 'Optimisation énergétique'],
    link: '/pompes-chaleur',
    linkText: 'Voir les PAC',
    iconBg: 'bg-orange-500',
    checkColor: 'text-orange-400',
    image: 'https://readdy.ai/api/search-image?query=heat%20pump%20outdoor%20unit%20installation%20energy%20efficient%20heating%20system%20Switzerland%20modern%20home%20clean%20background%20professional&width=600&height=380&seq=pac-univers-02&orientation=landscape',
  },
];

const renovationServices = [
  {
    icon: 'ri-home-gear-line',
    title: 'Travaux de Rénovation',
    description: 'Tous types de travaux de rénovation intérieure et extérieure. Transformation complète, rénovation partielle, finitions soignées.',
    features: ['Rénovation complète', 'Cuisine & salle de bain', 'Peinture & revêtements', 'Menuiserie & parquet'],
    link: '/renovation',
    linkText: 'Voir la rénovation',
    iconBg: 'bg-emerald-500',
    checkColor: 'text-emerald-600',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20home%20renovation%20interior%20transformation%20Switzerland%20bright%20living%20room%20white%20walls%20wooden%20floor%20professional%20quality%20craftsmanship%20clean%20minimal%20design%20warm%20light&width=600&height=380&seq=renovation-univers-01&orientation=landscape',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Références & Réalisations',
    description: 'Découvrez nos projets de rénovation réalisés en Suisse romande. Des transformations complètes qui témoignent de notre savoir-faire.',
    features: ['Avant / Après', 'Projets résidentiels', 'Projets commerciaux', 'Témoignages clients'],
    link: '/renovation#references',
    linkText: 'Voir les références',
    iconBg: 'bg-teal-500',
    checkColor: 'text-teal-400',
    image: 'https://readdy.ai/api/search-image?query=stunning%20before%20after%20home%20renovation%20project%20Switzerland%20modern%20kitchen%20bathroom%20living%20room%20transformation%20professional%20photography%20portfolio%20showcase%20quality%20craftsmanship&width=600&height=380&seq=references-univers-01&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services">

      {/* UNIVERS 1 — TECHNIQUE */}
      <div className="bg-gray-950 py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-amber-500/20 border border-amber-500/40">
                  <i className="ri-tools-line text-amber-400"></i>
                </div>
                <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Univers Technique</span>
              </div>
              <h2 className="text-4xl font-bold text-white tracking-tight sm:text-5xl leading-tight">
                Expertise technique<br />
                <span className="text-amber-400">& installations</span>
              </h2>
              <p className="mt-4 text-gray-400 text-base max-w-xl leading-relaxed">
                Électricité, ventilation, sanitaire et pompes à chaleur — des techniciens certifiés pour tous vos travaux à Neuenegg et en Suisse romande.
              </p>
            </div>
            <div className="flex flex-wrap gap-x-8 gap-y-3 lg:flex-col lg:items-end lg:gap-3">
              {[
                { icon: 'ri-shield-check-line', label: 'Certifiés NIBT / OIBT', color: 'text-amber-400' },
                { icon: 'ri-time-line', label: 'Intervention 24/7', color: 'text-amber-400' },
                { icon: 'ri-map-pin-line', label: 'Neuenegg & Fribourg', color: 'text-amber-400' },
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-400">
                  <i className={`${b.icon} ${b.color}`}></i>
                  <span>{b.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {techniqueServices.map((s, i) => (
              <div key={i} className="group bg-white/5 border border-white/8 rounded-2xl overflow-hidden hover:border-white/20 transition-all duration-300 hover:-translate-y-1 flex flex-col">
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className={`absolute top-4 left-4 w-9 h-9 flex items-center justify-center ${s.iconBg} rounded-lg`}>
                    <i className={`${s.icon} text-base text-white`}></i>
                  </div>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-sm font-bold text-white mb-2">{s.title}</h3>
                  <p className="text-gray-400 text-xs leading-relaxed mb-4 flex-1">{s.description}</p>
                  <ul className="space-y-1.5 mb-4">
                    {s.features.map((f, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <i className={`ri-check-line text-xs ${s.checkColor}`}></i>
                        <span className="text-xs text-gray-400">{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to={s.link} className="inline-flex items-center justify-between w-full px-4 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 text-xs font-semibold text-gray-300 hover:text-white transition-all cursor-pointer group/btn">
                    <span>{s.linkText}</span>
                    <i className="ri-arrow-right-line group-hover/btn:translate-x-1 transition-transform"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* UNIVERS 2 — RÉNOVATION */}
      <div className="bg-gray-950 py-24 border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-emerald-500/20 border border-emerald-500/40">
                  <i className="ri-home-gear-line text-emerald-400"></i>
                </div>
                <span className="text-xs font-bold tracking-widest uppercase text-emerald-400">Rénovation</span>
              </div>
              <h2 className="text-4xl font-bold text-white tracking-tight sm:text-5xl leading-tight">
                Rénovation<br />
                <span className="text-emerald-400">& transformation</span>
              </h2>
              <p className="mt-4 text-gray-400 text-base max-w-xl leading-relaxed">
                Tous types de travaux de rénovation — des artisans qualifiés pour transformer votre espace de vie.
              </p>
            </div>
            <div className="flex flex-wrap gap-x-8 gap-y-3 lg:flex-col lg:items-end lg:gap-3">
              {[
                { icon: 'ri-medal-line', label: 'Artisans certifiés', color: 'text-emerald-400' },
                { icon: 'ri-tools-line', label: 'Matériaux premium', color: 'text-emerald-400' },
                { icon: 'ri-calendar-check-line', label: 'Délais respectés', color: 'text-emerald-400' },
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-gray-400">
                  <i className={`${b.icon} ${b.color}`}></i>
                  <span>{b.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-7 max-w-4xl mx-auto">
            {renovationServices.map((s, i) => (
              <div key={i} className="group bg-white/5 border border-white/8 rounded-2xl overflow-hidden hover:border-white/20 transition-all duration-300 hover:-translate-y-1 flex flex-col">
                <div className="relative h-52 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className={`absolute top-4 left-4 w-9 h-9 flex items-center justify-center ${s.iconBg} rounded-lg`}>
                    <i className={`${s.icon} text-base text-white`}></i>
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="text-base font-bold text-white mb-2">{s.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4 flex-1">{s.description}</p>
                  <ul className="grid grid-cols-2 gap-x-4 gap-y-1.5 mb-5">
                    {s.features.map((f, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <i className={`ri-check-line text-xs ${s.checkColor}`}></i>
                        <span className="text-xs text-gray-400">{f}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to={s.link} className="inline-flex items-center justify-between w-full px-4 py-3 rounded-xl bg-white/5 hover:bg-white/10 text-sm font-semibold text-gray-300 hover:text-white transition-all cursor-pointer group/btn">
                    <span>{s.linkText}</span>
                    <i className="ri-arrow-right-line group-hover/btn:translate-x-1 transition-transform"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-gray-500 mb-6 text-sm">Un projet de rénovation ? Obtenez un devis gratuit en moins de 24h.</p>
            <a href="#contact" className="inline-flex items-center gap-2 rounded-lg bg-white px-8 py-4 text-sm font-semibold text-gray-900 hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-mail-send-line"></i>
              Demander un devis gratuit
            </a>
          </div>
        </div>
      </div>

    </section>
  );
}
